import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  PAGE: '/dh-datamaint/user/page',
  ADD: '/dh-datamaint/user/add',
  DELETE: '/dh-datamaint/user/delete',
  DETAIL: '/dh-datamaint/user/getById',
  UPDATE: '/dh-datamaint/user/update',
  ACTIVE: '/dh-datamaint/user/active',
  ROLE_LIST: '/dh-datamaint/role/listAll'
};

class UserModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.PAGE, { params: payload.data });
      res.data.records.forEach((item: any) => {
        item.remarks = item.remarks || '-';
      })

      return res;
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.UPDATE, payload.data);
    },

    async Active(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ACTIVE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async getRoleList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.ROLE_LIST, { params: payload.data });
    }
  };
}

export const userModule = new UserModule();
